import styled from 'styled-components'

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const TooltipContent = styled.div`
  display: flex;
  align-items: center;
  line-height: 18px;
  visibility: ${({ isVisible }) => isVisible ? 'visible' : 'hidden'};
  position: absolute;
  transform: translateX(-107%);
  background-color: #2E2D37;
  color: #ECEDF2;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 16px;;
  border-radius: 8px;
  width: 193px;
  height: 50px;
  text-align: center;
  z-index: 1;
  opacity: ${({ isVisible }) => isVisible ? 1 : 0};
  transition: opacity 0.3s ease-in-out;
  top: 32px;
`;

export const Arrow = styled.div`
   width: 20px;
  height: 12px;
  position: absolute;
  bottom: 50px;
  right: 0;
  transform: translateX(-50%);
  background-color: #2E2D37;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
`;

export const Stamp = styled.div`
  display: flex;
  width: 208px;
  height: 24px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  color: #1F7A45;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  background: rgba(39, 174, 96, 0.20);
  margin: 0 15px  18px 0;
  cursor: pointer;

  &:after {
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    background: url('/assets/img/icon-info.svg') no-repeat;
    background-size: 100%;
  }
`
